import type { DayNightPhase } from "../dayNightPhase.ts";
import type { Season } from "../season.ts";
import { SEASON_IDS } from "../season.ts";
import type { TileTerrain } from "../worldState.ts";

export const MAP_HEX_RADIUS = 4;
export const MAP_TILE_COUNT = 3 * MAP_HEX_RADIUS * (MAP_HEX_RADIUS + 1) + 1;

export const INITIAL_POPULATION = 7;
export const INITIAL_FOOD_SUPPLIES = 0;
export const INITIAL_TURN = 1;
export const VICTORY_POPULATION = 30;
export const DEFEAT_POPULATION = 0;
export const FOOD_BANK_GROWTH_THRESHOLD = 7;
export const FOOD_BANK_GROWTH_COST = 7;
export const GROWTH_STREAK_REQUIRED = 2;
export const FAMINE_STREAK_REQUIRED = 4;
export const TILE_FOOD_DEPLETION_STEP = 0.03;
export const TILE_FOOD_REGEN_STEP = 0.025;
export const TILE_FOOD_MIN_YIELD_FRACTION = 0.15;
export const TURNS_PER_SEASON = 12;
export const FIRE_EVENT_PROBABILITY = 0.03;
export const FIRE_DURATION_TURNS_MIN = 4;
export const FIRE_DURATION_TURNS_MAX = 10;

/** Default clan name when SelectTotem receives empty/whitespace input (en). */
export const DEFAULT_CLAN_NAME = "Your clan";

export const TERRAIN_FOOD_PRODUCTION: Record<TileTerrain, number> = {
  desert: 1,
  mountain: 6,
  swamp: 9,
  forest: 13,
  plains: 18,
  river: 35,
};

export const TERRAIN_BASE_WATER: Record<TileTerrain, number> = {
  desert: 2,
  mountain: 8,
  swamp: 22,
  forest: 14,
  plains: 12,
  river: 30,
};

export const SEASON_WATER_MULTIPLIER: Record<Season, number> = {
  spring: 1.15,
  summer: 0.9,
  autumn: 1.1,
  winter: 0.75,
};

export const TERRAIN_AMBIENT_PREDATOR_BASE: Record<TileTerrain, number> = {
  desert: 0,
  plains: 1,
  river: 1,
  mountain: 2,
  forest: 3,
  swamp: 3,
};

export const SEASON_AMBIENT_PREDATOR_MODIFIER: Record<Season, number> = {
  summer: 0,
  spring: 1,
  autumn: 1,
  winter: 2,
};

export const DAY_NIGHT_AMBIENT_PREDATOR_MODIFIER: Record<DayNightPhase, number> = {
  day: 0,
  dusk: 1,
  dawn: 1,
  night: 2,
};

export const AMBIENT_PREDATOR_LEVEL_MAX_SCORE = {
  none: 1,
  low: 3,
  medium: 5,
} as const;

export const TERRAIN_SPAWN_WEIGHTS: ReadonlyArray<{ terrain: TileTerrain; weight: number }> = [
  { terrain: "desert", weight: 18 },
  { terrain: "mountain", weight: 15 },
  { terrain: "swamp", weight: 12 },
  { terrain: "forest", weight: 22 },
  { terrain: "plains", weight: 25 },
  { terrain: "river", weight: 8 },
];

export const SEASONS: readonly Season[] = SEASON_IDS;
